import * as React from "react";
const SvgFiRrUrl = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-url_svg__a)">
      <path
        fill="#062147"
        d="m15.388 9.221-.314-3.659a.517.517 0 1 1 1.031-.085l.212 2.681.75-1.443a.517.517 0 0 1 .918 0l.75 1.443.21-2.681A.52.52 0 0 1 19.461 5h.002c.303 0 .541.26.515.562l-.314 3.659c-.031.44-.337.779-.706.779-.244 0-.471-.151-.601-.4L17.526 8l-.831 1.6c-.129.249-.356.4-.601.4-.368 0-.675-.339-.706-.779M10.614 10c.244 0 .471-.151.601-.4l.831-1.6.831 1.6c.129.249.356.4.601.4.368 0 .675-.339.706-.779l.314-3.659A.517.517 0 0 0 13.983 5h-.002a.52.52 0 0 0-.516.477l-.21 2.681-.75-1.443a.517.517 0 0 0-.918 0l-.75 1.443-.212-2.681a.518.518 0 1 0-1.031.085l.314 3.659c.031.44.337.779.706.779m-2.657 0c.368 0 .675-.339.706-.779l.314-3.659A.517.517 0 0 0 8.462 5H8.46a.52.52 0 0 0-.516.477l-.21 2.681-.75-1.443a.517.517 0 0 0-.918 0l-.75 1.443-.212-2.681a.518.518 0 1 0-1.031.085l.314 3.659c.031.44.337.779.706.779.244 0 .471-.151.601-.4L6.525 8l.831 1.6c.129.249.356.4.601.4M19 0H5C2.243 0 0 2.243 0 5v5c0 2.757 2.243 5 5 5a1 1 0 1 0 0-2c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v5c0 1.654-1.346 3-3 3a1 1 0 1 0 0 2c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m-.293 22.293a.999.999 0 1 1-1.414 1.414l-2.537-2.537A4.97 4.97 0 0 1 12 22c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5a4.97 4.97 0 0 1-.83 2.756zM12 20c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-url_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUrl;
